import { faEye, faEyeLowVision, faGear } from "@elynx/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Divider, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Stack, Tooltip, Typography } from "@mui/material";
import Enumerable from "linq";
import { useLocation } from "react-router";
import { UIViewEnum } from "../../common/enums/UIViewEnum";
import useCustomizedNavigationRoutes from "../../hooks/use-customized-navigation-routes/UseCustomizedNavigationRoutes";
import { IRoute, UIViewCategory, UIViewSubCategory } from "../../routes/routes";
import { INavigationItem } from "../../services/navigation-data-service/Models";
import NavigationViewListUtils from "./NavigationViewListUtils";
import { IUICustomizationViewCategorySettingsDTO } from "../../services/ui-customization-data-service/Models";

export type NavigationViewListSectionProps = {
    //open: boolean; // not needed for now but maybe when the get their heads out it might be
    navigationItem: INavigationItem;
    customizationSettings: IUICustomizationViewCategorySettingsDTO | undefined;
    viewAll: boolean;
    showActions: boolean;
    onClick: (navigationItem: INavigationItem, route: IRoute, shiftKey: boolean, ctrlKey: boolean) => void;
    onConfigureClick?: () => void;
    onViewAllClick?: () => void;
};

export default function NavigationViewGroupedListSection({
    //open,
    navigationItem,
    customizationSettings,
    viewAll,
    showActions,
    onClick,
    onConfigureClick,
    onViewAllClick
}: NavigationViewListSectionProps) {
    const location = useLocation();

    const navigationRoutes = useCustomizedNavigationRoutes(
        navigationItem.objectTypeID,
        navigationItem.objectID,
        customizationSettings,
        viewAll
    );

    const currentRoute = navigationRoutes.find(o => o.fullPath === location.pathname);

    const groupedRoutes = Enumerable.from(navigationRoutes)
        .groupBy(o => o.subCategory)
        .orderBy(o => o.key());

    return [
        <Stack
            direction="row"
            spacing={1}
            sx={{
                alignItems: "center",
                paddingLeft: 1,
                paddingRight: 1,
                paddingBottom: 1,
                position: showActions
                    ? "sticky"
                    : "relative",
                top: 0,
                backgroundColor: "background.paper",
                zIndex: showActions
                    ? 1
                    : 0
            }}
        >
            <Typography
                variant="subtitle1"
                sx={{
                    fontWeight: 700,
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    flex: '1 1 auto',
                }}>
                {navigationItem.title}
            </Typography>
            {showActions &&
                <Box sx={{
                    position: "sticky",
                    top: 0,
                }}>
                    <IconButton
                        size="small"
                        onClick={() => onViewAllClick?.()}
                    >
                        {viewAll
                            ? <Tooltip arrow placement="top" title="Viewing Full Menu">
                                <FontAwesomeIcon icon={faEye} />
                            </Tooltip>
                            : <Tooltip arrow placement="top" title="Viewing My Menu">
                                <FontAwesomeIcon icon={faEyeLowVision} />
                            </Tooltip>
                        }
                    </IconButton>
                    <IconButton size="small"
                        sx={{
                            marginLeft: "0 !important"
                        }}
                        onClick={() => onConfigureClick?.()}
                    >
                        <FontAwesomeIcon icon={faGear} />
                    </IconButton>
                </Box>
            }
        </Stack>,
        <List
            sx={{
                padding: 0,
                overflow: "hidden",
                display: 'flex',
                flexDirection: 'column',
                flex: '0 0 auto'
            }}
            dense={true}>
            {/* <Stack
                direction="row"
                spacing={1}
                sx={{
                    alignItems: "center",
                    paddingLeft: 1,
                    paddingRight: 1,
                    paddingBottom: 1,
                }}
            >
                <Typography
                    variant="subtitle1"
                    sx={{
                        fontWeight: 700,
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        flex: '1 1 auto',
                    }}>
                    {navigationItem.title}
                </Typography>
                {showActions &&
                    <>
                        <IconButton
                            size="small"
                            onClick={() => onViewAllClick?.()}
                        >
                            {viewAll
                                ? <Tooltip arrow placement="top" title="My Menu">
                                    <FontAwesomeIcon icon={faEyeLowVision} />

                                </Tooltip>
                                : <Tooltip arrow placement="top" title="Full Menu">
                                    <FontAwesomeIcon icon={faEye} />
                                </Tooltip>
                            }
                        </IconButton>
                        <IconButton size="small"
                            sx={{
                                marginLeft: "0 !important"
                            }}
                            onClick={() => onConfigureClick?.()}
                        >
                            <FontAwesomeIcon icon={faGear} />
                        </IconButton>
                    </>
                }
            </Stack> */}
            <Divider />
            {/* } */}
            {/* // Exclude routes that have a parent view from the navigation drawer/rail */}
            {groupedRoutes.toArray()
                .filter(o => o.key() !== undefined && o.toArray().length > 0)
                .map((o, index) =>

                    <ListItem key={index}
                        sx={{
                            flexDirection: 'column',
                            paddingTop: 0,
                            paddingBottom: 0
                        }}
                    >
                        {!customizationSettings?.ungrouped &&
                            <ListItemText
                                sx={{
                                    display: 'flex',
                                    alignSelf: 'flex-start',
                                }}
                                primary={<Typography
                                    variant="subtitle2"
                                    sx={{
                                        fontWeight: 700,
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        color: theme => theme.palette.grey[600],
                                    }}>
                                    {NavigationViewListUtils.getSubcategoryLabel(o.key()!)}
                                </Typography>

                                }
                            />
                        }
                        <List component="div" disablePadding sx={{ width: '100%' }}>

                            {o.toArray().sort((a, b) => (a.order ?? 0) - (b.order ?? 0)).map((route, ndx) =>
                                // Exclude routes that have a parent view from the navigation drawer/rail
                                (route.parentViewID === undefined) &&
                                <ListItemButton
                                    key={ndx}
                                    disableGutters
                                    selected={route.viewID === (currentRoute?.parentViewID ?? currentRoute?.viewID)}
                                    onClick={(event) => onClick && onClick(navigationItem, route, event.shiftKey, event.ctrlKey)}>

                                    <ListItemIcon>
                                        <Tooltip arrow placement="right"
                                            //title={!open ? route.name : ""}
                                            title=""
                                        >
                                            <Box>
                                                {<route.icon />}
                                            </Box>
                                        </Tooltip>

                                    </ListItemIcon>

                                    <ListItemText primary={route.name} />
                                </ListItemButton>
                            )}
                        </List>
                    </ListItem>
                )}
        </List>
    ];
}


export type UICustomizationSettingsModel = {
    navigationDrawer: UICustomizationNavigationDrawerSettingsModel
}

export type UICustomizationNavigationDrawerSettingsModel = {
    openOnHover: boolean;
    viewCategories: UICustomizationViewCategoryListSettingsModel;
}

export type UICustomizationViewCategoryListSettingsModel = {
    group: UICustomizationViewCategorySettingsModel;
    device: UICustomizationViewCategorySettingsModel;
    well: UICustomizationViewCategorySettingsModel;
    tankBattery: UICustomizationViewCategorySettingsModel;
    tank: UICustomizationViewCategorySettingsModel;
    tag: UICustomizationViewCategorySettingsModel;
}

export type UICustomizationViewCategorySettingsModel = {
    ungrouped: boolean;
    views: Array<UICustomizationViewSettingsModel>;
}

export type UICustomizationViewSettingsModel = {
    viewID: UIViewEnum;
    hidden: boolean;
    order?: number;
    //are these needed? they're not stored
    name: string;
    category?: UIViewCategory;
    subCategory?: UIViewSubCategory;
}